<onyx-badge
  color="light-blue"
  [size]="20"
  [leftIcon]="badgeIcon()"
  (mouseenter)="showDropdown()"
  (mouseleave)="hideDropdown()"
>
  {{ orderStageNumber() | translate }}
</onyx-badge>

@if (isDropdownAttached()) {
  <div
    class="dropdown"
    (mouseenter)="showDropdown()"
    (mouseleave)="hideDropdown()"
  >
    <header class="f-body-s f-muted">
      {{ `${I18N}.heading` | translate }}
    </header>

    @if (loading()) {
      <div class="loading f-body-s f-muted">
        <onyx-spinner [size]="24"></onyx-spinner>

        {{ 'labels.loadingMessage' | translate }}
      </div>
    } @else {
      @for (stage of stages(); track stage) {
        <app-order-modal-stage-item
          [order]="order()"
          [stage]="stage"
          [acceptedProposal]="acceptedProposal()"
          [hasManualProposal]="hasManualProposal()"
        ></app-order-modal-stage-item>
      }
    }
  </div>
}
